const frontpage = {
  videos: document.getElementsByTagName('video'),
  titles: document.getElementsByClassName('js-text-animation'),
  items: document.getElementsByClassName('js-slide'),
  skip: document.getElementById('js-slide-skip'),
};

let itemIndex = 0;

function frontpageItems(n) {
  itemIndex = n;

  // Reset the index at last index
  if (n > frontpage.items.length - 1) {
    itemIndex = 0;
  }

  // Stop all videos, remove active class
  for (let i = 0; i < frontpage.items.length; i += 1) {
    frontpage.items[i].classList.remove('c-slider__slide--active');
    frontpage.videos[i].pause();
  }

  // Set current and play
  frontpage.items[itemIndex].classList.add('c-slider__slide--active');
  frontpage.videos[itemIndex].play();
}

function nextClip() {
  frontpageItems((itemIndex += 1));
}

export default function InitFrontpage() {
  if (document.body.classList.contains('home')) {
    // Add end listeners to videos
    for (let i = frontpage.videos.length - 1; i >= 0; i -= 1) {
      frontpage.videos[i].addEventListener('ended', nextClip, false);
    }

    // Set listener to skip
    frontpage.skip.addEventListener('click', nextClip, false);

    // Start frontpage
    frontpageItems(0);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/frontpage.js